import React, { FC } from 'react'
import { ClassNameValue } from 'tailwind-merge'
import cn from '../../../lib/utils/cn'
import { WorkspaceType } from './interfaces.table'

interface WorkspaceSwitcherProps {
	workspace: WorkspaceType
	onChange: (type: WorkspaceType) => void
	className?: ClassNameValue
	classNameItem?: ClassNameValue
	disabled?: boolean
	labels?: {
		all?: string
		personal?: string
		organization?: string
	}
	withAll?: boolean
	withColorLabels?: boolean
}

// TOD: this component will removed. We should use one switcher everywhere. It's "components/ui/UniversalSwitcher.tsx"

const WorkspaceSwitcher: FC<WorkspaceSwitcherProps> = ({
	workspace,
	onChange,
	className,
	classNameItem,
	disabled = false,
	labels,
	withAll = false,
	withColorLabels = false,
}) => (
	<div
		className={cn(
			'flex items-center justify-center rounded-lg overflow-hidden h-9',
			className
		)}
	>
		{withAll && (
			<button
				onClick={() => onChange('all')}
				className={cn(
					'w-fit px-4 h-full rounded-l-lg disabled:opacity-50 box-border',
					workspace === 'all'
						? 'text-white bg-text-main dark:bg-text-main-dark dark:text-text-main'
						: 'bg-white dark:bg-background-dark text-text-main dark:text-text-main-dark border border-stroke-light dark:border-stroke-light-dark  border-r-0 hover:bg-background-light transition-colors duration-200 ease-in-out',
					classNameItem
				)}
				disabled={disabled}
			>
				{labels?.all ?? 'All'}
			</button>
		)}
		<button
			onClick={() => onChange('personal')}
			className={cn(
				'w-fit px-4 h-full disabled:opacity-50 flex items-center justify-center gap-1.5 box-border',
				!withAll && 'rounded-l-lg',
				workspace === 'personal'
					? 'text-white bg-text-main dark:bg-text-main-dark dark:text-text-main'
					: 'bg-white dark:bg-background-dark text-text-main dark:text-text-main-dark border border-stroke-light dark:border-stroke-light-dark  border-r-0 hover:bg-background-light transition-colors duration-200 ease-in-out',
				classNameItem
			)}
			disabled={disabled}
		>
			{withColorLabels && (
				<div className="h-4 w-0.5 rounded-full bg-blue-500" />
			)}
			{labels?.personal ?? 'Personal'}
		</button>
		<button
			disabled={disabled}
			onClick={() => onChange('organization')}
			className={cn(
				'w-fit px-4 h-full rounded-r-lg disabled:opacity-50 flex items-center justify-center gap-1.5 box-border',
				workspace === 'organization'
					? 'text-white bg-text-main dark:bg-text-main-dark dark:text-text-main'
					: 'bg-white dark:bg-background-dark text-text-main dark:text-text-main-dark border border-stroke-light dark:border-stroke-light-dark border-l-0 hover:bg-background-light transition-colors duration-200 ease-in-out',
				workspace == 'all' && 'border-l',
				classNameItem
			)}
		>
			{withColorLabels && (
				<div className="h-[14px] w-0.5 rounded-full bg-teal-500" />
			)}
			{labels?.organization ?? 'Organization'}
		</button>
	</div>
)

export default WorkspaceSwitcher
